import { config, handleResponse } from '../../_helpers';

export const freightRateServices = {
    getAllFreightRates,
    getFreightRates,
    createFreightRate,
    updateFreightRate,
    getFreightRateById,
    deleteFreightRates,
    activation,
    searchFreightRates,
    getFreightRateListByCode,
    groupByChargeCode,
    readGroupCharge,
    loadChargeByChargeCodeOrigin
};
function getAllFreightRates() {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/freightRates`, requestOptions).then(handleResponse);
}
function getFreightRates(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/freightRates/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/freightRates/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }

}
function createFreightRate(freightRate, userProfile) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            dateEffective: freightRate.dateEffective,
            chargeCode: freightRate.chargeCode,
            portCodeOrigin: freightRate.portCodeOrigin,
            portCodeDestination: freightRate.portCodeDestination,
            fastandardRates: freightRate.fastandardRates,
            stdRateWvat: freightRate.stdRateWvat,
            userCreated: userProfile.userId,
            branchCodeOrigin: freightRate.branchCodeOrigin,
            branchCodeDestination: freightRate.branchCodeDestination,
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/FreightRates`, requestOptions).then(handleResponse);
}
function updateFreightRate(freightRate, userProfile) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({
            dateEffective: freightRate.dateEffective,
            chargeCode: freightRate.chargeCode,
            portCodeOrigin: freightRate.portCodeOrigin,
            portCodeDestination: freightRate.portCodeDestination,
            fastandardRates: freightRate.fastandardRates,
            stdRateWvat: freightRate.stdRateWvat,
            userModified: userProfile.userId,
            branchCodeOrigin: freightRate.branchCodeOrigin,
            branchCodeDestination: freightRate.branchCodeDestination,
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/FreightRates/update/${freightRate.id}`, requestOptions).then(handleResponse);
}
function getFreightRateById(id) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/FreightRates/get/${id}`, requestOptions).then(handleResponse);
}
function deleteFreightRates(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/FreightRates/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };

    return fetch(`${config.apiUrl}/FreightRates/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function searchFreightRates(take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/freightRates/load?filter=${filter}&search=${search}&take=${take}`, requestOptions).then(handleResponse);
}
function getFreightRateListByCode(code, destination, origin) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/FreightRates/ReadListByCode?chargecode=${code}&branchcodedestination=${destination}&branchcodeorigin=${origin}`, requestOptions).then(handleResponse);
}
function groupByChargeCode() {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/FreightRates/groupByChargeCode`, requestOptions).then(handleResponse);
}
function readGroupCharge(chargeCode) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/FreightRates/readGroupCharge?chargeCode=${chargeCode}`, requestOptions).then(handleResponse);
}
function loadChargeByChargeCodeOrigin(charge, branchOrigin, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/FreightRates/loadChargeByChargeCodeOrigin?chargeCode=${charge}&branchCodeOrigin=${branchOrigin}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/FreightRates/loadChargeByChargeCodeOrigin?chargeCode=${charge}&branchCodeOrigin=${branchOrigin}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}